type MenuPriceItem = {
  category: string;
  price: number;
  priceText?: string;
};

export type PizzaSizeOption = {
  value: "10-inch" | "18-inch";
  label: string;
  priceCents: number;
  priceAdjustment: number;
};

function dollarsToCents(value: string) {
  const amount = Number.parseFloat(value.replace(/[^0-9.]/g, ""));
  return Number.isFinite(amount) ? Math.round(amount * 100) : null;
}

export function getPizzaSizeOptionsFromPriceText(
  priceText: string | undefined,
  basePrice: number,
): PizzaSizeOption[] {
  const parts = priceText?.split("/").map((part) => part.trim()) ?? [];
  if (parts.length !== 2) return [];

  const smallPriceCents = dollarsToCents(parts[0]);
  const largePriceCents = dollarsToCents(parts[1]);
  if (smallPriceCents === null || largePriceCents === null) return [];

  const basePriceCents = Math.round(basePrice * 100);

  return [
    {
      value: "10-inch",
      label: '10"',
      priceCents: smallPriceCents,
      priceAdjustment: smallPriceCents - basePriceCents,
    },
    {
      value: "18-inch",
      label: '18"',
      priceCents: largePriceCents,
      priceAdjustment: largePriceCents - basePriceCents,
    },
  ];
}

export function getDefaultPizzaSizeValue(
  options: readonly PizzaSizeOption[],
): PizzaSizeOption["value"] | null {
  return options.find((option) => option.value === "10-inch")?.value ?? null;
}

export function formatMenuItemPriceLabel(item: MenuPriceItem) {
  if (item.category === "pizza") {
    const options = getPizzaSizeOptionsFromPriceText(item.priceText, item.price);
    if (options.length === 2) {
      return `${options[0].label} $${(options[0].priceCents / 100).toFixed(2)} / ${options[1].label} $${(options[1].priceCents / 100).toFixed(2)}`;
    }
  }

  return item.priceText ?? `$${item.price.toFixed(2)}`;
}
